import React, { useState, Fragment } from "react"

import { Button, Modal, } from "components"
import ComboModalDoneButton from "./ComboModalDoneButton"
import ComboModalHeader from "./ComboModalHeader"
import ComboModalCard from "./ComboModalCard"
import classes from "./index.module.scss"

const ComboModal = props => {
  const {
    combo,
    onExited,
    openModal,
    setOpenModal,
    initialValues,
    orderComboIndex
  } = props

  const editMode = !!initialValues

  const initialSelectedComboItemsState =
    editMode ? initialValues : []

  const [selectedComboItems, setSelectedComboItems] =
    useState(initialSelectedComboItemsState)

  return (
    <Modal
      size="lg"
      backdrop="static"
      show={openModal}
      onExited={onExited}
      onHide={() => setOpenModal(false)}
    >
      <div className={classes["container"]}>
        <ComboModalHeader
          combo={combo}
          selectedComboItems={selectedComboItems}
        />

        <div className={classes["main"]}>
          {combo.comboSets.map((comboSet, comboSetIndex) => (
            <Fragment key={comboSet._id}>
              <div className={classes["title"]}>
                آپشن {comboSetIndex + 1}
              </div>
              <div className={classes["group"]}>
                {comboSet.items.map((comboSetItem, ciIndex) => (
                  <div
                    key={ciIndex}
                    className={classes["card"]}
                  >
                    <ComboModalCard
                      comboSetItem={comboSetItem}
                      comboSetId={comboSet._id}
                      comboSetBranchId={comboSet.branchId}
                      comboSetIndex={comboSetIndex}
                      selectedComboItems={selectedComboItems}
                      setSelectedComboItems={setSelectedComboItems}
                    />
                  </div>
                ))}
              </div>
            </Fragment>
          ))}
        </div>

        <div className={classes["footer"]}>
          <Button
            color="danger"
            onClick={() => setOpenModal(false)}
            className={classes["button"]}
          >
            لغو
          </Button>

          <ComboModalDoneButton
            combo={combo}
            editMode={editMode}
            orderComboIndex={orderComboIndex}
            setOpenModal={setOpenModal}
            selectedComboItems={selectedComboItems}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ComboModal